import { render, staticRenderFns } from "./AdTypeIncomeRateReport.vue?vue&type=template&id=d72f0b16&scoped=true"
import script from "./AdTypeIncomeRateReport.vue?vue&type=script&lang=js"
export * from "./AdTypeIncomeRateReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d72f0b16",
  null
  
)

export default component.exports